<template>
  <div :class="['page', isCard && 'card', PCcard && 'card']">
    <div :class="['content', isCard && 'card', PCcard && 'PCcard']">
      <div :class="['t-box', isCard && 'card', PCcard && 'PCcard']">
        <div class="t_l">
          <div class="l">{{ chartMinData.shortName }}</div>
          <div class="n">{{ chartMinData.symbol }}</div>
        </div>
        <div class="t_r">
          <div :class="{
            'val-green': chartMinData.riseFallRange < 0,
            'val-grey': getInfoColor(chartMinData.riseFall),
            'val-red': true,
            'l': true
          }">{{ toDecimal(chartMinData.yesdayPrice) }} </div>
          <div class="n">
            <span :class="{
              'val-green': chartMinData.riseFallRange < 0,
              'val-grey': getInfoColor(chartMinData.riseFall),
            }" class="val val-red">{{ chartMinData.riseFall }}</span>
            <span
              :class="{ 'val-green': chartMinData.riseFallRange < 0, 'val-grey': getInfoColor(chartMinData.riseFall) }"
              class="val val-red">
              {{ chartMinData.riseFallRange }} %</span>
          </div>
        </div>
      </div>
      <kChart :kdata="kData" :symbol="SymbolCode" :type="type" :market-data="marketData" @setma="setma"
        :isCard="isCard || PCcard">
        <template v-slot:rightTool>
          <div :class="['maOptions', PCcard && 'PCcard']" v-if="type != 'boll'">
            <span class="item" v-if="type == 'ma'" style="margin-right: 5px;">
              <span class="label">MA(5,10,20,60,120)</span>
            </span>
            <span class="item">
              <span class="label ma5">MA5</span><span class="val ma5">{{ toDecimal(maData.MA5) || "--" }}</span>
            </span>
            <span class="item">
              <span class="label ma10">MA10</span><span class="val ma10">{{ toDecimal(maData.MA10) || "--" }}</span>
            </span>
            <span class="item">
              <span class="label ma20">MA20</span><span class="val ma20">{{ toDecimal(maData.MA20) || "--" }}</span>
            </span>
            <span class="item">
              <span class="label ma60">MA60</span><span class="val ma60">{{ toDecimal(maData.MA60) || "--" }}</span>
            </span>
            <span class="item" v-if="type == 'ma'">
              <span class="label ma120">MA120</span>
              <span class="val ma120">{{ toDecimal(maData.MA120) || "--" }}</span>
            </span>
          </div>
          <div :class="['maOptions', PCcard && 'PCcard']" v-else>
            <span class="item" style="margin-right: 5px;">
              <span class="label">BOLL(20,2)</span>
            </span>
            <span class="item">
              <span class="label MID">MID</span><span class="val MID">{{ toDecimal(maData.MID) || "--" }}</span>
              <span class="label UPPER">UPPER</span><span class="val UPPER">{{ toDecimal(maData.UPPER) || "--" }}</span>
              <span class="label LOWER">LOWER</span><span class="val LOWER">{{ toDecimal(maData.LOWER) || "--" }}</span>
            </span>
          </div>
        </template>
      </kChart>
    </div>
  </div>
</template>

<script>
import kChart from '../kChart.vue'
import moment from 'moment'
import mixin from '../js/mixin'
export default {
  components: {
    kChart
  },
  props: {
    resdata: {},
    urlId: {
      type: String,
      default: ''
    },
    isCard: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      shortNameShow: '', // 当前订阅数据的名称
      kData: [], // 订阅数据K图数组
      maData: {}, // 存放当前MA数据
      chartMinData: {
        councilProfit: '', // 本局收益
        yesdayPrice: 0.0, // 昨收价
        latestPrice: 0.0, // 最新价
        riseFall: 0.0, // 涨跌
        riseFallRange: 0.0, // 涨跌幅
        shortName: '', // 当前的k线图的名称
        endtime: null,
        symbol: '' // 代码
      },
      SymbolCode: '', // 订阅某个编码数据
      marketData: [],
      taskID: '',
      isloading: false,
      gid: '', // 文件名
      type: 'macd', // 指标类型
      PCcard: false
    }
  },
  created () {
    this.PCcard = !!this.isCard
    this.onInitkData()
  },
  methods: {
    toDecimal (v) {
      if (!v || v === 'NAN' || v === '-') {
        return '--'
      }
      return parseFloat(v).toFixed(2)
    },
    // 初始化K线数据
    onInitkData () {
      this.IsOrder = false
      this.isloading = true
      this.SymbolCode = ''

      this.chartMinData = {
        councilProfit: '', // 本局收益
        latestPrice: 0.0, // 最新价
        riseFall: 0.0, // 涨跌
        riseFallRange: 0.0, // 涨跌幅
        purchNum: 0, // 买入数量
        purchShowNum: 0, // 买入数量展示
        purchNumSall: 0, // 已经买入的数量
        purchNumMax: 10, // 当前最大的买入数量
        sellOutNum: 0, // 卖出数量
        sellOutShowNum: 0, // 卖出数量展示
        sellOutNumSall: 0, // 能卖出最大数量
        sellOutNumMax: 0, // 当前最大的卖出数量
        endtime: null
      }
      this.marketData = []
      // 获取
      this.isloading = false
      this.kData = []

      let resdata = this.resdata

      let klineData = (typeof resdata === 'string') ? ((resdata && JSON.parse(resdata).data && JSON.parse(resdata).data.kLineQuotes) || []) : resdata.data.kLineQuotes

      klineData.forEach((ele, index) => {
        let obj = this.getTypeData(ele, index)
        const item = {
          ...ele['quoteData'],
          ...obj.data
        }
        // 头金叉死叉标识
        let state = this.stateIcon(item, this.type)
        if (state) {
          const date = moment(new Date(item.UTCDateTime)).format('yyyy-MM-DD')

          this.marketData.push({
            name: 'Mark',
            // symbol: 'image://' + require('@/static/images/' + state + '.png'),
            coord: [`${date}`, this.getLabelVal(item, this.type), state],
            type: state,
            value: item.macd,
            symbolSize: document.body.clientWidth > 750 ? [16, 16] : [12, 12],
            symbolOffset: document.body.clientWidth > 750 ? [0, state.includes('金叉') ? 8 : -6] : [0, state.includes('金叉') ? 8 : -6],
            itemStyle: {
              color: state.includes('金叉') ? '#B60707' : '#0CB90C',
              opacity: 0.8
            }
          })
        }
        this.kData.push(item)
      })
      console.log('金叉死叉标识', this.type, this.marketData)
      // 设置数据
      let data = this.kData[this.kData.length - 1]
      // let dataLen = this.kData.length - 1
      this.chartMinData.latestPrice = data['LastPrice']
      this.chartMinData.yesdayPrice = data['PrePrice'] // 昨收价
      this.chartMinData.riseFall = data['LastPriceChange']
      this.chartMinData.riseFallRange = this.toDecimal(
        mixin.accMul(data['ChangeRatio'], 100),
        2,
        true
      ) // 涨跌幅

      this.chartMinData.shortName = (typeof resdata === 'string') ? (JSON.parse(resdata).data.ShorName) : resdata.data.ShorName
      this.chartMinData.symbol = (typeof resdata === 'string') ? (JSON.parse(resdata).data.symbol) : resdata.data.symbol
    },
    // 获取MA的数据
    setma (attr, val) {
      this.$set(this.maData, attr, val)
    },
    // 颜色状态控制
    getInfoColor (val) {
      let flag = false
      // 昨收价相等
      if (this.chartMinData.latestPrice === this.chartMinData.yesdayPrice) {
        flag = true
      }
      // 昨收价相等
      if (val === 0) {
        flag = true
      }
      return flag
    },
    // 头叉标识
    stateIcon (item, type) {
      let image = 0
      // 1、MACD空头， 2、MACD多头，3、低位金叉，4、低位死叉，5、高位金叉，6、高位死叉
      switch (type) {
        case 'macd':
          if (item.macd_lowgolden) {
            image = '高位金叉'
          } else if (item.macd_lowdeath) {
            image = '高位死叉'
          } else if (item.macd_highgolden) {
            image = '高位金叉'
          } else if (item.macd_highdeath) {
            image = '高位死叉'
          }
          break;

        case 'kdj':
          if (item.kdj_golden) {
            image = '高位金叉'
          } else if (item.kdj_death) {
            image = '高位死叉'
          }
          break;

        case 'rsi':
          if (item.rsi_golden) {
            image = '高位金叉'
          } else if (item.rsi_death) {
            image = '高位死叉'
          }
          break;

        case 'ma':
          if (item.ma_golden) {
            image = '高位金叉'
          } else if (item.ma_death) {
            image = '高位死叉'
          }
          break;

        case 'bias':
          if (item.bias_golden) {
            image = '高位金叉'
          } else if (item.bias_death) {
            image = '高位死叉'
          }
          break;

        case 'wr':
          if (item.wr_golden) {
            image = '高位金叉'
          } else if (item.wr_death) {
            image = '高位死叉'
          }
          break;

        case 'psy':
          if (item.psy_golden) {
            image = '高位金叉'
          } else if (item.psy_death) {
            image = '高位死叉'
          }
          break;

        case 'dmi':
          if (item.dmi_golden) {
            image = '高位金叉'
          } else if (item.dmi_death) {
            image = '高位死叉'
          }
          break;

        case 'vol':
          if (item.vol_golden) {
            image = '高位金叉'
          } else if (item.vol_death) {
            image = '高位死叉'
          }
          break;
      }
      return image
    },
    // 获取指标类型
    getTypeData (obj, index) {
      let labels = ['macd', 'kdj', 'rsi', 'boll', 'ma', 'bias', 'wr', 'psy', 'dmi', 'vol'] // 预设所有指标
      let data
      for (const key in obj) {
        if (obj[key] && labels.includes(key)) {
          data = obj[key]
          if (index === 0) { this.type = key }
        }
      }
      return { type: this.type, data }
    },
    // 获取不同指标的金叉空叉值
    getLabelVal (item, type) {
      let attr
      switch (type) {
        case 'macd':
          attr = 'macd_dea'
          break;
        case 'kdj':
          attr = 'kdj_k'
          break;
        case 'rsi':
          attr = 'rsi_6'
          break;
        case 'ma':
          attr = 'ma_5'
          break;
        case 'bias':
          attr = 'bias_6'
          break;
        case 'wr':
          attr = 'wr_6'
          break;
        case 'psy':
          attr = 'psy'
          break;
        case 'dmi':
          attr = 'dmi_mdi'
          break;
        case 'vol':
          attr = 'volma_5'
          break;
      }
      return item[attr]
    }
  }
}
</script>

<style lang="less">
.page {
  padding: 40rpx;
  height: calc(100vh - 80rpx);
  background-image: linear-gradient(#f5f5f5, #fff);
  padding: 16px;
  background-color: #f5f5f5;

  &.card {
    padding: 20rpx;
    height: auto;
    background-color: #f5f5f5;
    background-image: none;
    border-radius: 10rpx;
  }

  &.PCcard {
    padding: 20rpx;
    height: auto;
    background-color: #f5f5f5;
    background-image: none;
    border-radius: 10rpx;
  }

  .content {
    &.card {
      padding: 0px;
      width: 100%;
    }

    &.PCcard {
      padding: 0px;
      width: 100%;
    }

    background-color: #fff;
    border-radius: 20rpx;

    .t-box {
      background-color: #f5f5f5;
      display: flex;
      justify-content: space-between;
      margin-bottom: 60rpx;
      border-radius: 20rpx;
      padding: 20rpx 40rpx;

      &.card {
        margin-bottom: 0rpx;
        border-radius: 0px;
      }

      &.PCcard {
        margin-bottom: 0rpx;
        border-radius: 0px;
      }

      p {
        margin: 40rpx 0;

      }

      &.PCcard {
        .t_l {
          .l {
            font-size: 30rpx;
          }

          .n {
            font-size: 30rpx;
          }
        }

        .t_r {
          .l {
            font-size: 30rpx;

          }

          .n {
            font-size: 30rpx;
          }
        }
      }

      .t_l {
        text-align: left;

        .l {
          font-size: 48rpx;
          color: #333;
          margin-bottom: 10rpx !important;
          padding: 5px 0px;

          @media (max-width: 750px) {
            font-size: 30rpx;
          }

          @media (max-width: 420px) {
            font-size: 30rpx;
          }
        }

        .n {
          font-size: 42rpx;
          color: #999999;
          padding-bottom: 5px;

          @media (max-width: 420px) {
            font-size: 30rpx;
          }
        }
      }

      .t_r {
        color: #ec0000;
        text-align: right;

        &.fall {
          color: #00da3c;
        }

        .l {
          font-size: 48rpx;
          margin-bottom: 10rpx;

          @media (max-width: 750px) {
            font-size: 30rpx;
          }

          @media (max-width: 420px) {
            font-size: 30rpx;
          }

        }

        .n {
          font-size: 48rpx;

          @media (max-width: 420px) {
            font-size: 30rpx;
          }

          text {
            margin-right: 20rpx;

            &:last-child {
              margin-right: 0;
            }
          }
        }

        .val-red {
          color: #ff0000;
        }

        .val-green {
          color: #008000;
          padding: 5px 0px;
        }

        .val-grey {
          color: #333;
        }
      }
    }

    .maOptions {
      font-size: 32rpx;
      display: flex;
      justify-content: flex-start;
      padding: 0 4rpx;
      width: 100%;

      // overflow: auto;
      &.PCcard {
        font-size: 24rpx;
      }

      @media (max-width: 750px) {
        font-size: 24rpx;
      }

      @media (max-width: 400px) {
        font-size: 24rpx;
      }

      .item {
        margin-right: 30rpx;
        margin-bottom: 20rpx;
      }

      .label {
        margin-right: 6rpx;
        font-size: 24rpx;

        @media (max-width: 400px) {
          font-size: 20rpx;
        }

        color: #333;

        &.ma5 {
          color: #39afe6;
        }

        &.ma10 {
          color: #da6ee8;
        }

        &.ma20 {
          color: #ffab42;
        }

        &.ma60 {
          color: #00940b;
        }

        &.ma120 {
          color: #FF7786;
        }

        &.MID {
          color: #7499E4;
        }

        &.UPPER {
          color: #FF7786;
        }

        &.LOWER {
          color: #339900;
        }
      }

      .val {
        margin-right: 30rpx;
        font-size: 24rpx;

        @media (max-width: 400px) {
          font-size: 20rpx;
        }

        &.ma5 {
          color: #39afe6;
        }

        &.ma10 {
          color: #da6ee8;
        }

        &.ma20 {
          color: #ffab42;
        }

        &.ma60 {
          color: #00940b;
        }

        &.ma120 {
          color: #FF7786;
        }

        &.MID {
          color: #7499E4;
        }

        &.UPPER {
          color: #FF7786;
        }

        &.LOWER {
          color: #339900;
        }

        &:last-child {
          margin-right: 0;
        }
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/chart/KLine/index.vue